import useUserContext from "hooks/context-hooks/useUserContext";
import { useEffect, useState } from "react";
import { getOneCallLog } from "services/callsService";

export const useGetOneCallLog = (callLogId: string | number | undefined) => {
  const [data, setData] = useState<CallLog | null>(null);
  const [loading, setLoading] = useState<boolean>(!!callLogId);
  const [error, setError] = useState<unknown>(null);
  const { token, officeId } = useUserContext();

  useEffect(() => {
    if (!callLogId) return;

    const fetchCallLog = async () => {
      try {
        setLoading(true);
        const response = await getOneCallLog({ token, officeId }, callLogId);
        setData(response.data.data as CallLog);
      } catch (err) {
        console.error(err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchCallLog();
  }, [callLogId]);

  return { data, loading, error };
};

export interface CallLog {
  id: number;
  contact_name: string;
  phone_number: string;
  duration: number;
  call_type: "incoming" | "outgoing" | "missed";
  created_at: string;
  // Add other fields as needed
}

export interface Office {
  id: string;
}

export interface GetCallLogParams {
  token: string;
  current_office: Office;
}
